import { Component, Inject } from '@angular/core';
import { Http, Response, Headers, RequestOptionsArgs } from '@angular/http';
import { LocalizePipe } from '../../pipes/Localize.pipe';
import { Configuration } from '../../configurations/shared.config';
import { IErrorHandler } from '../../dataModels/contracts/IErrorHandler';

@Component({
    moduleId: module.id,
    selector: '[language-picker]',
    templateUrl: 'language-picker.component.html',
    providers: [LocalizePipe]
})
export class LanguagePicker {

    private _errorHandler: IErrorHandler;

    constructor(private _http: Http, @Inject("IErrorHandler") handler: IErrorHandler, private _localizer: LocalizePipe) {

        this._errorHandler = handler;
    }

    changeLanguage(language: string) {
        this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.userPreferenceUrl + language)
            .subscribe(response => {
                window.location.reload();

            }, error => {

                this._errorHandler.Handle(this._localizer.transform(Configuration.messages.defaultErrorMessage));
            })
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/languagePicker/language-picker.component.ts